import React, { useContext } from 'react';
import { ViewDashboardContext } from '../../../shared/entities/view/components/view-dashboard/ViewDashboardContext';
import { SearchResultsFilterGroupName } from '../../enums/SearchResultsFilterGroupName';
import { ViewDataTable } from '../../../shared/entities/view/components/view/interfaces/api/ViewDataTable';
import SearchResultsGrid from './SearchResultsGrid';
import { ComponentMessage } from '../../../shared/enums/ComponentMessage';
import { companiesCustomColumnsSettings } from '../../shared/constants/custom-columns-settings/companiesCustomColumnsSettings';

interface Props {
  onChange?: () => void;
}

const SearchResultsCompaniesGrid: React.FC<Props> = props => {
  const data = useContext(ViewDashboardContext)?.data?.[SearchResultsFilterGroupName.Companies] as ViewDataTable;

  return (
    <SearchResultsGrid
      gridTitle={'Companies'}
      dataTable={data}
      customColumnsSettings={companiesCustomColumnsSettings}
      overlayNoRowsTemplate={ComponentMessage.NoData}
      onChange={props.onChange}
    />
  );
};

export default SearchResultsCompaniesGrid;
